const HeroSection = () => (
  <section id="top" className="relative scroll-mt-[68px] overflow-hidden border-b border-border bg-grad-hero">
    <div
      className="grid-motif pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_80%_70%_at_30%_30%,#000_30%,transparent_80%)]"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -right-[220px] -top-[280px] h-[720px] w-[720px] rounded-full bg-[radial-gradient(circle,var(--orb),transparent_65%)]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-[1200px] px-[clamp(16px,5vw,48px)] pb-[clamp(48px,8vw,88px)] pt-[clamp(64px,12vw,152px)]">
      <div className="inline-flex items-center gap-2.5 rounded-full border border-border bg-card py-1.5 pl-2.5 pr-3 font-mono text-xs uppercase tracking-[0.06em] text-muted-foreground">
        <span className="h-[7px] w-[7px] rounded-full bg-accent shadow-[0_0_0_4px_var(--focus-ring)]" aria-hidden="true" />
        <span>Yerevan, Armenia</span>
      </div>

      <h1 className="text-balance mt-7 max-w-[15ch] text-[clamp(40px,7.4vw,100px)] font-semibold leading-none tracking-[-0.045em]">
        We build tools for how software gets made <span className="gradient-text">with AI</span>.
      </h1>

      <p className="text-pretty mt-7 max-w-[600px] text-[clamp(17px,1.6vw,21px)] leading-[1.55] text-muted-foreground">
        Sksenq is a small team in Yerevan building products for developers and AI agents who write software side by
        side.
      </p>

      <div className="mt-10 flex flex-wrap gap-3">
        <a
          href="#products"
          className="inline-flex min-h-[54px] items-center justify-center gap-3 rounded-xl bg-btn px-[26px] text-base font-semibold text-[color:var(--btn-fg)] shadow-primary transition-[transform,box-shadow] hover:-translate-y-px hover:text-[color:var(--btn-fg)] hover:shadow-glow"
        >
          Explore TaskDuck
          <span aria-hidden="true">→</span>
        </a>
        <a
          href="#contact"
          className="inline-flex min-h-[54px] items-center justify-center rounded-xl border border-border bg-card px-6 text-base font-medium text-foreground hover:border-accent hover:text-foreground"
        >
          Get in touch
        </a>
      </div>

      <div className="mt-[clamp(56px,8vw,96px)] flex flex-wrap items-center gap-x-4 gap-y-2.5 border-t border-border pt-5 font-mono text-[13px] tracking-[0.03em] text-muted-foreground">
        <span className="text-accent-text">Now building</span>
        <span className="h-px w-5 bg-border" aria-hidden="true" />
        <span className="text-foreground">TaskDuck</span>
        <span>coordination for people and AI coding agents</span>
      </div>
    </div>
  </section>
);

export default HeroSection;
